import React from 'react';
import { Search, Target, PenTool, MessageSquare } from 'lucide-react';
export function AuthoritySection() {
  const steps = [{
    icon: <Search className="w-8 h-8 text-emerald-600" data-id="element-1" />,
    title: 'Deep Audience Research',
    description: "I don't guess. I analyze your market, your competitors, and your customers' voice to find the exact hooks that convert."
  }, {
    icon: <Target className="w-8 h-8 text-emerald-600" data-id="element-2" />,
    title: 'Positioning Refinement',
    description: "We clarify exactly where you sit in the market so you're not competing on price, but on value and authority."
  }, {
    icon: <PenTool className="w-8 h-8 text-emerald-600" data-id="element-3" />,
    title: 'Conversion Messaging',
    description: "I write copy designed to sell, using psychological triggers that move prospects from 'interested' to 'invested'."
  }, {
    icon: <MessageSquare className="w-8 h-8 text-emerald-600" data-id="element-4" />,
    title: 'Voice Retention',
    description: 'Your brand, your voice. I ensure the copy sounds exactly like you, just a more persuasive, profitable version.'
  }];
  return <section id="approach" className="py-24 bg-slate-50" data-id="element-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-7">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-8">
            More Than Just Words. <br data-id="element-9" />
            <span className="text-emerald-600" data-id="element-10">
              A Strategic Revenue System.
            </span>
          </h2>
          <p className="text-lg text-slate-600" data-id="element-11">
            I don't just write "pretty" copy. I build systems that turn
            strangers into high-ticket clients. Here is my proven framework.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-12">
          {steps.map((step, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-13">
              <div className="bg-emerald-50 w-16 h-16 rounded-lg flex items-center justify-center mb-6" data-id="element-14">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-15">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-16">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}